$(document).ready(function () {
  $(".our-products-slider-ud .slider_inrr_main").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    centerMode: true,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0741/6800/9023/files/Frame_7.png" alt="Previous"></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0741/6800/9023/files/Frame_6.png" alt="Next"></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 371,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  $(".reviews-slider-main-ud .reviews_slider_inrr").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0741/6800/9023/files/Frame_7.png" alt="Previous"></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0741/6800/9023/files/Frame_6.png" alt="Next"></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  $(document).on("click", ".product-scroll-btn", function () {
    $("html, body").animate(
      {
        scrollTop: $(".product-new-main-section").offset().top,
      },
      2000
    );
  });

  const popupWrappers = document.querySelectorAll(
    ".popup-wrapper:not(.no-close)"
  );
  function close_popup(wrapper) {
    (wrapper.style.display = "none"),
      wrapper.querySelectorAll("video").forEach((video) => {
        video.paused || video.pause();
      });
  }
  popupWrappers.forEach((wrapper) => {
    wrapper.addEventListener("click", (e2) => {
      e2.target === wrapper && (e2.preventDefault(), close_popup(wrapper));
    });
  });
  const closeButtons = document.querySelectorAll(".close-popup");
  closeButtons.forEach((button) => {
    button.addEventListener("click", (e2) => {
      e2.preventDefault();
      const wrapper = button.closest(".popup-wrapper");
      wrapper && close_popup(wrapper);
    });
  });

  function handleVideoClick() {
    const prodVidContainers = document.querySelectorAll(".video-preview-wrap"),
      videoPopupMedia = document.getElementById("video-popup-media"),
      videoPopup = document.getElementById("video-popup");
    prodVidContainers.forEach((container) => {
      container.addEventListener("click", () => {
        const videoSrc = container.dataset.src;
        videoSrc &&
          ((videoPopupMedia.querySelector("source").src = videoSrc),
          (videoPopup.style.display = "block"),
          videoPopup.addEventListener("transitionend", () => {
            videoPopup.style.opacity = 1;
          }),
          videoPopupMedia.load(),
          videoPopupMedia.play(),
          (videoPopupMedia.muted = !1));
      });
    });
  }
  handleVideoClick();
  function section_social_videos(videoSection) {
    const videoPlayers = videoSection.querySelectorAll("video");
    let currentVideoIndex = videoPlayers.length;
    let videos_loaded = false;

    function playNextVideo() {
      // Increment the index and reset if it exceeds the array length
      currentVideoIndex++;
      if (currentVideoIndex >= videoPlayers.length) {
        currentVideoIndex = 0;
      }

      // Pause all videos and remove "active" class from all video list items
      for (let i3 = 0; i3 < videoPlayers.length; i3++) {
        videoPlayers[i3].pause();
        videoPlayers[i3].closest("li").classList.remove("active");
      }

      // Get the current video and update its source if necessary
      const current_video = videoPlayers[currentVideoIndex];
      for (let source in current_video.children) {
        const videoSource = current_video.children[source];
        if (
          typeof videoSource.tagName === "string" &&
          videoSource.tagName === "SOURCE"
        ) {
          videoSource.src = videoSource.dataset.src;
        }
      }

      // Add the "active" class to the current video list item and play the video
      current_video.closest("li").classList.add("active");
      current_video.play();

      // Automatically switch to the next video after 5 seconds
      setTimeout(playNextVideo, 5000);
    }

    function loadVideos() {
      if (!videos_loaded) {
        videos_loaded = true;
        for (let i3 = 0; i3 < videoPlayers.length; i3++) {
          const current_video = videoPlayers[i3];
          for (let source in current_video.children) {
            const videoSource = current_video.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }
          current_video.load();
        }
      }
    }

    const scrollHandler = function () {
      if (
        videoSection.getBoundingClientRect().top >= 0 &&
        videoSection.getBoundingClientRect().bottom <= window.innerHeight
      ) {
        loadVideos();
        playNextVideo();
        window.removeEventListener("scroll", scrollHandler);
      }
    };

    window.addEventListener("scroll", scrollHandler);
  }

  const videoSections = document.querySelectorAll(".autoplay-videos");
  for (let i = 0; i < videoSections.length; i++) {
    section_social_videos(videoSections[i]);
  }


  
  // ================ Image with text section slider ==================//
  $(".image_with_text_cstm_main .image_main_ryt").slick({
    arrows: true,
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0741/6800/9023/files/Frame_7.png" alt="Previous"></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0741/6800/9023/files/Frame_6.png" alt="Next"></button>',
  });


  
}); // == Ready Close
